<template>
    <div class="d-flex mb-2">
        <div class="input-group">
            <input
                name="name"
                :value="localFilter.name"
                class="form-control"
                @input="searchName"
                :placeholder="trans('Search')"
                type="search"
                autocomplete="off"
            >
            <div class="input-group-append">
                    <span class="input-group-text">
                        <i class="icofont-search"></i>
                    </span>
            </div>
        </div>

        <button
            class="fields-group__title ml-2 position-relative"
            :class="isFilterActive ? 'filter-active' : ''"
            aria-expanded="false"
            @click="openFilterModal"
            :title="trans('Filter')"
        >
            <i class="icofont-filter"></i>
        </button>
    </div>

    <Teleport to="body" v-if="showFilterModal">
        <div class="modal show">
            <div class="modal-backdrop show" :style="{ zIndex: 'unset' }" @click.self="close()"></div>
            <section class="modal-dialog" :style="{ zIndex: 1 }">
                <div class="container popup">
                    <div class="modal-content">
                        <div class="modal-header">
                            <div class="modal-title">{{ trans('Filter') }}</div>

                            <button
                                type="button"
                                class="close"
                                data-dismiss="modal"
                                aria-label="Close"
                                @click="close()"
                                :disabled="modalLoading"
                            >
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>

                        <div class="modal-body" v-if="!modalLoading">

                            <div class="form-group d-flex align-items-center justify-content-between">
                                <label class="mb-0" for="free">{{ trans('Free on') }}:</label>

                                <div class="input-group w-65">
                                    <vue-flatpickr
                                        :modelValue="localFilter.free"
                                        @update:modelValue="onFreeSelectDate"
                                        :config="{
                                                dateFormat: 'Y-m-d',
                                                altFormat: 'd/m/Y',
                                            }"
                                        :placeholder="trans('Select date')"
                                        name="free"
                                        class="form-control bg-white"
                                        autocomplete="off"
                                    >
                                    </vue-flatpickr>
                                </div>
                            </div>

                            <hr>

                            <div class="form-group d-flex align-items-center justify-content-between">
                                <label class="mb-0" for="department_id">{{ trans('Department') }}:</label>

                                <div class="input-group w-65">
                                    <v-select
                                        :modelValue="null"
                                        @update:modelValue="onDepartmentSelect"
                                        :options="optionsOfDepartments"
                                        :placeholder="trans('Select...')"
                                        id="department_id"
                                        label="title"
                                    >
                                        <template #option="{ title, persons_count, equipments_count }">
                                            <span>{{ title }}</span>
                                            <span v-if="persons_count > 0 || equipments_count > 0" class="text-muted ml-2">
                                                <span v-if="persons_count > 0">
                                                    <i class="icofont-user-alt-1"></i>{{ persons_count }}
                                                </span>
                                                <span v-if="equipments_count > 0" :class="{ 'ml-1': persons_count > 0 }">
                                                    <i class="icofont-vehicle-cement"></i>{{ equipments_count }}
                                                </span>
                                            </span>
                                        </template>
                                        <template #selected-option="{ title }">
                                            {{ title }}
                                        </template>
                                    </v-select>
                                </div>
                            </div>
                            <div
                                v-if="localFilter.department_ids.length"
                                class="w-65 ml-auto">
                                <div
                                    v-for="departmentId in localFilter.department_ids"
                                    class="badge badge-pill badge-secondary btn btn-sm cursor-pointer text- mr-2 mb-2"
                                    style="text-transform: none"
                                    @click="unselectDepartment(departmentId)"
                                >
                                    {{ departments[departmentId].title }}
                                    <span
                                        class="ml-1"
                                    >&#x2715;</span>
                                </div>
                            </div>

                            <div class="form-group d-flex align-items-center justify-content-between">
                                <label class="mb-0" for="team_id">{{ trans('Team') }}:</label>

                                <div class="input-group w-65">
                                    <v-select
                                        :modelValue="null"
                                        @update:modelValue="onTeamSelect"
                                        :options="optionsOfTeams"
                                        :placeholder="trans('Select...')"
                                        id="team_id"
                                        label="title"
                                    >
                                        <template #option="{ title, persons_count, equipments_count }">
                                            <span>{{ title }}</span>
                                            <span v-if="persons_count > 0 || equipments_count > 0" class="text-muted ml-2">
                                                <span v-if="persons_count > 0">
                                                    <i class="icofont-user-alt-1"></i>{{ persons_count }}
                                                </span>
                                                <span v-if="equipments_count > 0" :class="{ 'ml-1': persons_count > 0 }">
                                                    <i class="icofont-vehicle-cement"></i>{{ equipments_count }}
                                                </span>
                                            </span>
                                        </template>
                                        <template #selected-option="{ title }">
                                            {{ title }}
                                        </template>
                                    </v-select>
                                </div>
                            </div>
                            <div
                                v-if="localFilter.team_ids.length"
                                class="w-65 ml-auto">
                                <div
                                    v-for="teamId in localFilter.team_ids"
                                    class="badge badge-pill badge-secondary btn btn-sm cursor-pointer text- mr-2 mb-2"
                                    style="text-transform: none"
                                    @click="unselectTeam(teamId)"
                                >
                                    {{ teams[teamId].title }}
                                    <span
                                        class="ml-1"
                                    >&#x2715;</span>
                                </div>
                            </div>


                            <hr>

                            <div class="form-group d-flex align-items-center justify-content-between">
                                <label class="mb-0" for="job_id">{{ trans('Job') }}:</label>

                                <div class="input-group w-65">
                                    <v-select
                                        :modelValue="null"
                                        @update:modelValue="onJobSelect"
                                        :options="optionsOfJobs"
                                        :placeholder="trans('Select...')"
                                        id="job_id"
                                        label="text"
                                    >
                                    </v-select>
                                </div>
                            </div>
                            <div
                                v-if="localFilter.job_ids.length"
                                class="w-65 ml-auto">
                                <div
                                    v-for="jobId in localFilter.job_ids"
                                    class="badge badge-pill badge-secondary btn btn-sm cursor-pointer text- mr-2 mb-2"
                                    style="text-transform: none"
                                    @click="unselectJob(jobId)"
                                >
                                    {{ jobs[jobId].title }}
                                    <span
                                        class="ml-1"
                                    >&#x2715;</span>
                                </div>
                            </div>


                            <!-- Certificates-->
                            <div class="form-group d-flex align-items-center justify-content-between">
                                <label class="mb-0" for="certificates">{{ trans('Certificates') }}:</label>

                                <div class="input-group w-65">
                                    <v-select
                                        :modelValue="null"
                                        @update:modelValue="onCertificateSelect"
                                        :options="optionsOfCertificates"
                                        :placeholder="trans('Select...')"
                                        id="certificates"
                                        label="text"
                                    >
                                    </v-select>
                                </div>
                            </div>
                            <div
                                v-if="localFilter.certificate_ids.length"
                                class="w-65 ml-auto">
                                <div
                                    v-for="certificateId in localFilter.certificate_ids"
                                    class="badge badge-pill badge-secondary btn btn-sm cursor-pointer text- mr-2 mb-2"
                                    style="text-transform: none"
                                    @click="unselectCertificate(certificateId)"
                                >
                                    {{ certificates[certificateId].title }}
                                    <span
                                        class="ml-1"
                                    >&#x2715;</span>
                                </div>
                            </div>

                            <!-- Skills-->
                            <div class="form-group d-flex align-items-center justify-content-between">
                                <label class="mb-0" for="skills">{{ trans('Skills') }}:</label>

                                <div class="input-group w-65">
                                    <v-select
                                        :modelValue="null"
                                        @update:modelValue="onSkillSelect"
                                        :options="optionsOfSkills"
                                        :placeholder="trans('Select...')"
                                        id="skills"
                                        label="text"
                                    >
                                    </v-select>
                                </div>
                            </div>
                            <div class="form-group">
                                <ul class="list-group" v-if="localFilter.skills && localFilter.skills.length > 0">
                                    <li
                                        v-for="(skill, index) of localFilter.skills"
                                        :key="skill.id"
                                        class="list-group-item d-flex justify-content-between align-items-center px-0 py-1"
                                        style="min-height: 0"
                                    >
                                        <div class="col">
                                            {{ skills[skill.id].title }}
                                        </div>

                                        <div class="col col-auto ml-auto">
                                            <div class="stars-wrapper">
                                                <star-rating-component
                                                    @select="onSetSkillRate"
                                                    :id="skill.id"
                                                    :value="skill.stars"
                                                ></star-rating-component>
                                            </div>
                                        </div>

                                        <div class="col col-auto p-0 pr-1">
                                            <button
                                                type="button"
                                                class="close"
                                                aria-label="Close"
                                                @click.prevent="onSkillRemove(index)"
                                            >
                                                <span aria-hidden="true">&times;</span>
                                            </button>
                                        </div>
                                    </li>
                                </ul>
                            </div>


                            <hr>

                            <!-- sorting-->
                            <div class="form-group d-flex align-items-center justify-content-between">
                                <label class="mb-0">{{ trans('Sort') }}:</label>

                                <div class="input-group w-65">
                                    <v-select
                                        v-model="localSortBy"
                                        :reduce="option => option.id"
                                        :options="optionsOfSorting"
                                        :placeholder="trans('Select...')"
                                        label="text"
                                    >
                                    </v-select>
                                </div>
                            </div>

                            <hr>

                            <div class="d-flex justify-content-between">
                                <div>
                                    {{ trans('Save these filter settings as default') }}
                                </div>
                                <div class="switch-form">
                                    <label class="switch">
                                        <input
                                            type="checkbox"
                                            :value="true"
                                            name="saveFilter"
                                            v-model="saveFilter"
                                        />
                                        <span
                                            class="slider round"
                                        ></span>
                                    </label>
                                </div>
                            </div>


                        </div>

                        <div class="modal-body" v-if="modalLoading">
                            <div class="text-center">
                                <i class="icofont-spinner"></i>
                            </div>
                        </div>
                        <!--/ modal-body -->

                        <div class="modal-footer">
                            <button type="button" class="btn btn-outline-secondary mr-auto" @click="clearLocalFilter">
                                {{ trans('Clear filter') }}
                            </button>

                            <button
                                type="button"
                                @click="close()"
                                class="btn btn-secondary"
                                :disabled="modalLoading"
                            >
                                {{ trans('Cancel') }}
                            </button>
                            <button
                                type="button"
                                class="btn btn-primary"
                                @click="applyFilter"
                                :disabled="modalLoading"
                            >
                                {{ trans('Filter') }}
                            </button>
                        </div>

                    </div>
                </div>
            </section>
        </div>
    </Teleport>
</template>

<script>
import VueFlatpickr from 'vue-flatpickr-component';
import vSelect from "vue-select";
import StarRatingComponent from "../../../helpers/StarRatingComponent.vue";
import {cloneDeep, debounce} from "lodash";
import {mapActions, mapGetters, mapState} from "vuex";
import {DEFAULT_FILTER} from "../../../../constants";

export default {
    components: {
        VueFlatpickr,
        vSelect,
        StarRatingComponent,
    },
    data() {
        return {
            modalLoading: false,
            showFilterModal: false,
            saveFilter: false,
            localFilter: DEFAULT_FILTER.filter,
            localSortBy: DEFAULT_FILTER.sort,

            skills: {},
            certificates: {},
            jobs: {},
            departments: {},
            teams: {},

            optionsOfSorting: [
                { id: 'order', text: trans('Manual') },
                { id: 'name', text: trans('Name ascending') },
                { id: '-name', text: trans('Name descending') },
                // Job in comment, because this causes issues with sorting equipments - can be adeed later
                // { id: 'job', text: trans('Job ascending') },
                // { id: '-job', text: trans('Job descending') },
            ],
        };
    },
    computed: {
        ...mapState('planningFilter', [
            'filter',
            'sort',
        ]),
        ...mapGetters('planningFilter', [
            'isFilterActive',
        ]),
        optionsOfTeams() {
            return Object.values(this.teams).map((item) => {
                return {
                    id: item.id,
                    title: item.title,
                    persons_count: item.persons_count,
                    equipments_count: item.equipments_count,
                };
            });
        },
        optionsOfSkills() {
            return Object.values(this.skills).map((item) => {
                return {
                    id: item.id,
                    text: item.title + ' (' + item.persons_count + ')',
                    stars: 1,
                };
            });
        },
        optionsOfDepartments() {
            return Object.values(this.departments).map((item) => {
                return {
                    id: item.id,
                    title: item.title,
                    persons_count: item.persons_count,
                    equipments_count: item.equipments_count,
                };
            });
        },
        optionsOfJobs() {
            return Object.values(this.jobs).map((item) => {
                return {
                    id: item.id,
                    text: item.title + ' (' + item.persons_count + ')',
                };
            });
        },
        optionsOfCertificates() {
            return Object.values(this.certificates).map((item) => {
                return {
                    id: item.id,
                    text: item.title + ' (' + item.persons_count + ')',
                };
            });
        },
    },
    methods: {
        ...mapActions('planningFilter', [
            'storeFilter',
        ]),
        openFilterModal() {
            this.localFilter = cloneDeep(this.filter);
            this.localSortBy = this.sort;
            this.saveFilter = false;
            this.showFilterModal = true;
        },
        applyFilter(){
            this.storeFilter({
                filter: cloneDeep(this.localFilter),
                sort: this.localSortBy,
                saveFilter: this.saveFilter
            });
            this.close();
        },
        searchName: debounce(function (event) {
            this.localFilter.name = event.target.value; // Update local state immediately
            this.storeFilter({
                filter: cloneDeep(this.localFilter),
                sort: this.localSortBy,
                saveFilter: false
            });
        }, 300),
        close(){
            this.showFilterModal = false;
        },
        getInfoForFilters() {
            if (this.modalLoading) return; // Prevent concurrent calls
            this.modalLoading = true;

            axios
                .get(route('persons.get-filter-data'))
                .then((response) => {
                    this.teams = response.data.teams;
                    this.skills = response.data.skills;
                    this.jobs = response.data.jobs;
                    this.departments = response.data.departments;
                    this.certificates = response.data.certificates;
                })
                .finally(() => {
                    this.modalLoading = false;
                });
        },
        onFreeSelectDate(value) {
            this.localFilter.free = value
        },
        onJobSelect(job) {
            if (job.id !== 0 && !this.localFilter.job_ids.includes(job.id)) {
                this.localFilter.job_ids.push(job.id);
            }
        },
        unselectJob( jobId){
            this.localFilter.job_ids = this.localFilter.job_ids.filter((job) => {
                return job !== jobId;
            });
        },
        onDepartmentSelect(department) {
            if (department.id !== 0 && !this.localFilter.department_ids.includes(department.id)) {
                this.localFilter.department_ids.push(department.id);
            }
        },
        unselectDepartment( departmentId){
            this.localFilter.department_ids = this.localFilter.department_ids.filter((department) => {
                return department !== departmentId;
            });
        },
        onTeamSelect(team) {
            if (team.id !== 0 && !this.localFilter.team_ids.includes(team.id)) {
                this.localFilter.team_ids.push(team.id);
            }
        },
        unselectTeam( teamId){
            this.localFilter.team_ids = this.localFilter.team_ids.filter((team) => {
                return team !== teamId;
            });
        },
        onCertificateSelect(certificate) {
            if (certificate.id !== 0 && !this.localFilter.certificate_ids.includes(certificate.id)) {
                this.localFilter.certificate_ids.push(certificate.id);
            }
        },
        unselectCertificate( certificateId){
            this.localFilter.certificate_ids = this.localFilter.certificate_ids.filter((certificate) => {
                return certificate !== certificateId;
            });
        },
        onSkillSelect(skill) {
            if (skill.id !== 0 && !this.localFilter.skills.includes(skill)) {
                this.localFilter.skills.push(skill);
            }
        },
        onSkillRemove(index) {
            this.localFilter.skills.splice(index, 1);
        },
        onSetSkillRate(data) {
            if (data.rate && data.skill_id) {
                this.localFilter.skills.forEach((skill) => {
                    if (skill.id == data.skill_id) {
                        skill.stars = data.rate;
                    }
                });
            }
        },
        clearLocalFilter() {
            const defaults = DEFAULT_FILTER;

            this.localFilter = defaults.filter;
            this.localSortBy = defaults.sort;
            this.saveFilter = false;

            this.localFilter.name = this.filter.name;
        },
    },
    mounted() {
        this.localFilter = cloneDeep(this.filter);
        this.localSortBy = this.sort;
        this.getInfoForFilters();
    },
    watch: {
        filter: {
            handler(newValue) {
                this.localFilter = cloneDeep(newValue);
            },
            deep: true,
        },
        sort: {
            handler(newValue) {
                this.localSortBy = newValue;
            },
            deep: true,
        },
    }
};
</script>
<style lang="scss" scoped>
.w-65 {
    width: 65% !important;
}
.form-group {
    margin-bottom: 0.5rem;
}
.filter-active:after{
    content: '';
    position: absolute;
    top: -5px;
    right: -5px;
    width: 15px;
    height: 15px;
    border-radius: 100%;
    border: 1px solid #FFF;
    background-color: var(--main-color);
}
</style>
